// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3vFTN","list":"PatternAutocomplete_list__kozmq"};